import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from './url.service';
import { NotebookJsonMapping } from '../models/NotebookJsonMapping';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FabricNotebookJsonService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('FabricNotebookJson');
  }

  getNotebookCombinations(notebookName: string): Observable<NotebookJsonMapping[]> {
      return this.http.get<NotebookJsonMapping[]>(`${this.url}/GetNotebookCombinations`, {
        params: { notebookName }
      }).pipe(
        catchError((error: any) => this.handleError(error))
      );
    }

    private handleError(error: any): Observable<never> {
      console.error('An error occurred:', error);
      throw error;
    }
}
